'use strict';

var novicell = novicell || {}; // eslint-disable-line

// novicell.navigationMessage = novicell.navigationMessage || new function () {
//     this.init = function () {
//         window.location.href = document.querySelector("meta[http-equiv=refresh]").getAttribute("data-url");
//     };
// }();
